import { render } from "./Header.vue?vue&type=template&id=24a6729a&scoped=true"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=24a6729a&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a6729a"]])

export default __exports__